import '../../scss/acf-blocks/block-find-expert.scss';

const initFindExpert = () => {
    // Get all select elements with the class "js-select-state"
    const selectElements = document.querySelectorAll('.js-select-state');
    // Add change event listeners to each select element
    selectElements.forEach(function (selectElement) {
        selectElement.addEventListener('change', function () {
            // Get the selected option value
            const STATE = selectElement.value;
            const selectedCountry = document.querySelector(
                '.js-selected-country.active'
            ); // Assumes that the third class name is the tab name
            // get country val
            const COUNTRY = selectedCountry.dataset.tab; // Assumes that the third class name is the tab name
            const LOCATIONS = document.querySelectorAll(
                `.${COUNTRY} .js-locations`
            );
            if (STATE === 'none') {
                LOCATIONS &&
                    LOCATIONS.forEach(function (el) {
                        el.style.display = 'block';
                    });
            } else if (STATE && COUNTRY) {
                LOCATIONS &&
                    LOCATIONS.forEach(function (el) {
                        if (!el.classList.contains(STATE)) {
                            el.style.display = 'none';
                        } else {
                            el.style.display = 'block';
                        }
                    });
            }
        });
    });
};

document.defaultView.addEventListener(
    'DOMContentLoaded',
    initFindExpert,
    false
);

// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction('render_block_preview', initFindExpert);
}
